import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['countdown', 'text', 'timeUnits'];

  static classes = ['wide', 'narrow'];

  static values = {
    textStarted: String,
    textMinutes: String,
    textSeconds: String,
    startAt: String,
  };

  connect() {
    this.countdownEl = this.countdownTarget;
    this.timeUnitsEl = this.timeUnitsTarget;
    this.startAt = new Date(this.startAtValue);
    this.textWasReplaced = false;

    this.updateCountdown();
    this.timer = setInterval(() => this.updateCountdown(), 1000);
  }

  disconnect() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  }

  updateCountdown() {
    const diffMs = this.startAt - new Date().getTime();

    const distance = Math.abs(Math.floor(diffMs / 1000));

    if (diffMs <= 0) {
      if (distance >= 300) {
        this.closeBanner();
        return;
      }
      if (this.textWasReplaced === false) {
        this.replaceText();
      }
    }
    this.renderCountdown(distance);
  }

  closeBanner() {
    this.element.remove();
    if (this.timer) {
      clearInterval(this.timer);
    }
  }

  replaceText() {
    this.textTarget.innerHTML = this.textStartedValue;
    this.countdownEl = this.countdownTarget;
    this.timeUnitsEl = this.timeUnitsTarget;
    this.textWasReplaced = true;
  }

  renderCountdown(distance) {
    if (distance < 60) {
      this.countdownEl.textContent = distance;
      this.timeUnitsEl.textContent = `${this.textSecondsValue}`;
      this.shrinkCountdown();
    } else {
      const minutes = String(Math.floor(distance / 60)).padStart(1, '0');
      const seconds = String(distance % 60).padStart(2, '0');
      this.countdownEl.textContent = `${minutes}:${seconds}`;
      this.timeUnitsEl.textContent = `${this.textMinutesValue}`;
      this.expandCountdown();
    }
  }

  shrinkCountdown() {
    this.countdownTarget.classList.remove(this.wideClass);
    this.countdownTarget.classList.add(this.narrowClass);
  }

  expandCountdown() {
    this.countdownTarget.classList.remove(this.narrowClass);
    this.countdownTarget.classList.add(this.wideClass);
  }
}
